import { renderLinkOwnershipButton } from './LinkOwnershipButton';
import { renderProjectOwnershipWrapper } from './ProjectOwnershipWrapper';
import { renderReassignOwnerButton } from './ReassignOwnerButton';
import { renderVerifyOwnerButton } from './VerifyOwnerButton';

const renderProjectVerifyOwnerObserver = async () => {
  const verifyOwnerButtonClass = 'lo-status-tag verify-owner launch_verifyowner';
  const reassignOwnerMenuClass = 'actions-select-wrapper active';
  const setDealButtonId = 'launch-deal-id';
  const projectOwnershipWrapper = 'project-ownership-wrapper';

  var observer = new MutationObserver(function (mutations) {
    const wrapper = document.getElementsByClassName('ng-app-wrapper')[0] as HTMLElement;
    mutations
      .filter(
        (m) =>
          (m.target as HTMLElement).className === verifyOwnerButtonClass ||
          (m.target as HTMLElement).className === reassignOwnerMenuClass ||
          (m.target as HTMLElement).id === setDealButtonId ||
          (m.target as HTMLElement).id === projectOwnershipWrapper
      )
      .map((m) => m.target as HTMLElement)
      .forEach((element) => {
        if (element.className === verifyOwnerButtonClass) {
          renderVerifyOwnerButton(element, wrapper);
        } else if (element.className === reassignOwnerMenuClass) {
          const elements = Array.from(element.querySelectorAll('div')).filter((e) =>
            e.innerHTML.includes('Reassign Owner')
          );
          if (elements.length > 1) renderReassignOwnerButton(elements[1], wrapper);
        } else if (element.id === setDealButtonId) {
          renderLinkOwnershipButton(element, wrapper);
        } else if (element.id === projectOwnershipWrapper) {
          renderProjectOwnershipWrapper(element);
        }
      });
  });

  observer.observe(document, {
    subtree: true,
    attributes: true,
  });
};
if (
  window.location.pathname.startsWith('/dpackviewer') ||
  window.location.pathname.startsWith('/project/details')
) {
  const element = document.getElementById('project-ownership');
  if (element) renderProjectOwnershipWrapper(element);
}

if (
  window.location.pathname === '/projects' ||
  window.location.pathname.startsWith('/customers/profile') ||
  window.location.pathname.startsWith('/dataprotection/commvault') ||
  window.location.pathname.startsWith('/storage/netapp')
)
  renderProjectVerifyOwnerObserver();
